import { render, staticRenderFns } from "./AdmisionReporteEsfmUa.vue?vue&type=template&id=5c21dc22&scoped=true"
import script from "./AdmisionReporteEsfmUa.vue?vue&type=script&lang=js"
export * from "./AdmisionReporteEsfmUa.vue?vue&type=script&lang=js"
import style0 from "./AdmisionReporteEsfmUa.vue?vue&type=style&index=0&id=5c21dc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21dc22",
  null
  
)

export default component.exports